
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

@Component
export default class VehicleSourcePriceInformationField extends Vue {
  @Ref()
  childFormRef!: FormModel;

  @lazyInject(CarService)
  carService!: CarService;

  formModel = {
    price: '',
    officialPrice: '',
    managerPrice: '',
    sellerPrice: '',
  };

  rules = {
    price: [{ required: true, message: '请输入销售价格' }],
    // officialPrice: [{ required: true, message: '请输入新车价格' }],
    // managerPrice: [{ required: true, message: '请输入新车价格' }],
    // sellerPrice: [{ required: true, message: '请输入新车价格' }],
  };

  @Prop()
  value!: any;

  @Prop()
  readonly!: boolean;

  @Prop()
  dataSource!: any;

  @Prop()
  formDate: any;

  @Watch('formModel.price')
  price() {
    this.handleFormModelChange();
  }

  @Watch('formModel.interiorInfo')
  interiorInfo() {
    this.handleFormModelChange();
  }

  validItems: any = {};

  oldparams: any = {};

  async getEval() {
    console.log(this.formDate);
    if (!this.formDate) {
      return;
    }
    const { mileage, first_registration_date, car_model_id, plate_city_id } =
      this.formDate;

    const params = {
      plate_city_id,
      mileage,
      first_registration_date,
      model_id: car_model_id,
    };
    if (JSON.stringify(this.oldparams) === JSON.stringify(params)) {
      return;
    }
    this.oldparams = params;
    const res = await this.carService.getCarEval(params);
    console.log('res', res);
    if (!res.report) return;
    const { defaultCondition, evalInfo } = res.report;
    const validItems = evalInfo.find(
      (item: any) => item.condition == defaultCondition,
    );
    this.validItems = validItems;
  }

  getClass(val: any) {
    const { dealerBuy } = this.validItems;
    if (!dealerBuy) return '';
    if (val < dealerBuy.min) return 'color-badge';
    if (val > dealerBuy.max) return 'color-badge';
  }

  getPersonalTrade() {
    // console.log(this.validItems, 'ssdadadasdsadadasd');
    const { dealerBuy } = this.validItems;
    if (!dealerBuy) return '';
    const text = `${dealerBuy.min}~${dealerBuy.max}`;
    return text;
  }

  handleFormModelChange() {
    this.$emit('update', this.formModel);
  }

  mounted() {
    this.handleValueChange();
    this.getEval();
  }

  @Watch('value')
  handleValueChange() {
    this.formModel = this.value;
  }

  public async validateFields(): Promise<boolean> {
    try {
      const valid = await (this.childFormRef as any).validate();
      return valid;
    } catch (error) {
      // console.error('子表单校验失败:', error);
      return false;
    }
  }
}
